import React from "react";
import { useTranslation } from "react-i18next";
import { Radio } from "antd";

import FormItem from "../../FormItem";
import { RadioButton } from "./components";

export const GenderFormItem = ({
  name,
  label,
  radioStyle,
  showError,
  width,
  thirdOption,
  showThirdOption = true,
  additionalOptions,
  widthForAdditionalOptions,
  minWidth,
  minWidthForAdditionalOptions,
  required = true,
  formItemProps = {}
}) => {
  const { t } = useTranslation();
  const showErrorCondition = required && showError;
  return (
    <FormItem rules={[{ required }]} name={name} label={label} {...formItemProps}>
      <Radio.Group style={radioStyle}>
        <RadioButton showError={showErrorCondition} value="female" style={{ width: width || 115, minWidth: minWidth }}>
          {t("application_form_editor.genentech.copay.patient.female")}
        </RadioButton>
        <RadioButton showError={showErrorCondition} value="male" style={{ width: width || 115, minWidth: minWidth }}>
          {t("application_form_editor.genentech.copay.patient.male")}
        </RadioButton>
        {showThirdOption && (
          <RadioButton
            showError={showErrorCondition}
            value="other"
            style={{ width: widthForAdditionalOptions || width || null }}
          >
            {thirdOption || t("application_form_editor.genentech.copay.patient.prefer_no_answer")}
          </RadioButton>
        )}
        {!!additionalOptions &&
          additionalOptions.map((option, index) => (
            <RadioButton
              key={index}
              showError={showErrorCondition}
              value={option.value}
              style={{
                width: widthForAdditionalOptions || width || null,
                minWidth: minWidthForAdditionalOptions
              }}
            >
              {option.label}
            </RadioButton>
          ))}
      </Radio.Group>
    </FormItem>
  );
};
